module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normal-width": "90vw",
      "width": "960px",
      "set-class": "no-padding"
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "heading"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h1"
  }, [_c('h1', [_vm._v("Din bokning: " + _vm._s(_vm.order.resvid))])]), _vm._v(" "), (!_vm.onlyMore) ? _c('div', [(_vm.showQrCodeButton) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.openQrModal
    }
  }, [_vm._v("Visa QR-koder till liftkortsautomat")])]) : _vm._e(), _vm._v(" "), ((_vm.order && _vm.order.pickups ? _vm.order.pickups : []).length > 1 && _vm.SITE_CONFIG.site === 'branas') ? _c('div', {
    staticClass: "info",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_c('b', [_vm._v("OBS!")]), _vm._v(" Du har flera utlämningsställen valda för din bokning (" + _vm._s(_vm.order.pickups.join(', ')) + "). Kontakta gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(" om du vill ändra.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container",
    class: {
      disabled: _vm.loading
    }
  }, [_c('Cart', {
    attrs: {
      "use-storage": false,
      "order": _vm.order,
      "show-from-start": true
    },
    on: {
      "loading": function($event) {
        _vm.loading = true
      },
      "loadingcomplete": function($event) {
        _vm.loading = false
      },
      "changed": function($event) {
        _vm.reloadParent();
        _vm.fetch()
      }
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v(" ")])]) : _vm._e(), _vm._v(" "), (false && !_vm.loading && _vm.order.can_add_to_booking) ? _c('div', [_c('h2', [_vm._v("Komplettera din bokning:")]), _vm._v(" "), _c('div', {
    staticClass: "info",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.onlyMore) ? _c('div', [_vm._v("\n          För att boka tillägg till din boendebokning, såsom städ, linne eller matpåsar, välj ”Boka tillval” ovan.\n          "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v("\n        Du kan bara komplettera din bokning med bokningar inom samma datum som din grundbokning.\n      ")]), _vm._v(" "), (_vm.SITE_CONFIG.add_to_booking_open) ? _c('div', [_c('CompletedBookings', {
    attrs: {
      "add": true,
      "order-number": _vm.order.resvid,
      "order-number-numeric": _vm.order.headlid,
      "date-start": _vm.order.dateStart,
      "date-end": _vm.order.dateEnd,
      "helper-pool": _vm.order.firstAccomodationPoolLid,
      "helper-unit": _vm.order.firstAccomodationUnitLid
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.add_to_booking_open) ? _c('div', [_c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("Vid ändringar eller tillägg av din bokning, vänligen ring gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(".")])]) : _vm._e()]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e4c7dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/MyPages/MyBooking.vue
// module id = 995
// module chunks = 0